<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm-title">Preface</h2>
<p class="noindent">The inspiration for this book comes from a variety of life experiences—personal and observed. I have often witnessed people’s tendency to hold their past in higher regard than their future, which begs the question, “Why?” We are alive in the present with our whole future ahead of us, so why do we allow the past to control us today?</p>
<p class="indent">Enter <span class="aitalic">Slave No More</span>. The whole idea is to encourage the reader that being bound to their past is an option. Over the years, personal acquaintances have shared their stories with me and how they overcame adverse life circumstances. I wonder what separates Person A, the overcomer, from Person B, the bound one. Is there much difference? Or can we narrow it down to a mindset?</p>
<p class="indent">This book has been a few years in the writing, and in the process, I have learned more about how to free myself from limiting thoughts. As you follow a young man’s steps and lessons along the way, you will discover the power and effectiveness of having a strong vision to guide you through challenges. By the time you finish reading the book, I imagine that you will be ready to live with a sense of purpose, of being a slave no more.</p>
<p class="right"><span class="abold">Paul A. Henderson</span><br/>Richmond, VA</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm05.vue?608fe986